import axios from 'axios'
import {GetCookie, SetCookie, RemoveCookie} from './CookieService'
import dayjs from "dayjs";
import {getApiBase} from '@/lib/platform'

const contentTypeFile = [
    'application/pdf',
    'application/vnd.android.package-archive',
    'application/vnd.oasis.opendocument.text',
    'application/vnd.oasis.opendocument.spreadsheet',
    'application/vnd.oasis.opendocument.presentation',
    'application/vnd.oasis.opendocument.graphics',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.mozilla.xul+xml',
    'image/gif',
    'image/jpeg',
    'image/png',
    'image/tiff',
    'image/vnd.microsoft.icon',
    'image/x-icon',
    'image/vnd.djvu',
    'image/svg+xml',
];
const axiosInstance = axios.create({})

function formatDayjsObjects(data, config) {
    if (config && config['Content-Type'] && config['Content-Type'] !== 'multipart/form-data') {
        if (dayjs.isDayjs(data)) {
            return data.format(); // Default format can be changed as needed
        } else if (Array.isArray(data)) {
            return data.map(item => formatDayjsObjects(item));
        } else if (data !== null && typeof data === 'object') {
            return Object.keys(data).reduce((result, key) => {
                result[key] = formatDayjsObjects(data[key]);
                return result;
            }, {});
        } else {
            return data;
        }
    } else {
        return data;
    }
}

const TOKEN_NAME = process.env.REACT_APP_TOKEN_NAME
const NOT_AUTH = process.env.REACT_APP_NOT_AUTH
const EXPIRY_PASS = process.env.REACT_APP_EXPIRY_PASS
const CACHE_ROUTE = process.env.REACT_APP_CACHE_ROUTE

export const ApiService = (process_code, data, config = {}) => {
    // getApiBase() нь вэб дээр "" буцаана → relative URL (одоогийн зан төлөв хэвээр).
    // Capacitor (native) дээр REACT_APP_API_BASE-ээс серверийн бүтэн хаяг ирнэ, учир
    // нь апп нь localhost-оос ачаалагддаг тул relative URL серверт хүрэхгүй.
    return sendApiService('POST', getApiBase() + '/api/v1/process?' + process_code, formatDayjsObjects(data, config), process_code, config);
}

const error = {
    status: 'error',
    message: 'Хүсэлт илгээхэд алдаа гарлаа. Та дахин оролдоно уу.',
    info: ''
};

const getInfoRespError = (errors) => {
    let msg = error.message;
    if (errors.data) {
        if (errors.data.message) {
            msg = errors.data.message;
        } else {
            if (typeof errors.data === 'string') {
                msg = errors.data;
            } else {
                msg = JSON.stringify(errors.data);
            }
        }
    }
    return msg;
}
export const convertDayjsToDate = (obj) => {
    if (obj instanceof dayjs) {
        return obj.format("YYYY-MM-DD HH:mm:ss"); // Convert dayjs instance to JavaScript Date object
    }

    if (Array.isArray(obj)) {
        return obj.map(convertDayjsToDate); // Recursively handle arrays
    }

    if (obj && typeof obj === 'object' && obj instanceof FormData) {
        return obj;
    }

    if (obj && typeof obj === 'object') {
        const result = {};
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                result[key] = convertDayjsToDate(obj[key]); // Recursively handle object properties
            }
        }
        return result;
    }

    return obj; // Return the value if it's not a dayjs instance or object/array
}
export const sendApiService = (method, url, data, process_code, config = {}) => {
    const options = {
        method: method,
        url,
        ...(data?._download && {responseType: 'blob'}),
        headers: {
            'Content-Type': 'application/json', //'application/octet-stream'
            'Access-Control-Allow-Origin': '*',
            Authorization: 'Bearer ' + GetCookie(TOKEN_NAME),
            'pc': process_code,
            'language': localStorage.getItem('i18nextLngMeCoreBack') || 'mn',
            ...config
        }
    }

    if (process_code !== "lo000002") {
        localStorage.setItem('sessionTimer', new Date());
    }
    // options.data = data;
    options.data = convertDayjsToDate(data);

    const onSuccess = function (response) {
        // if (basicOptions !== null) return response
        RemoveCookie(NOT_AUTH);
        if (data?._download) {
            return response.data;
        }
        if (response?.data && response?.data.response_code) {
            if (response.data.response_code === "RC000000") {
                let data = response.data.response;
                if (data) {
                    if (data.next_page_url) {
                        data.total = data.to + 1;
                    } else if (data.prev_page_url) {
                        data.total = data.to;
                    } else if (data.data) {
                        data.total = data.data?.length;
                    }
                }
                return data;
            } else {
                return Promise.reject(response)
            }
        } else if (response?.data && response?.headers['content-type'] && contentTypeFile.includes(response?.headers['content-type'])) {
            return response;
        }
        return Promise.reject(response)
    }

    const onError = function (error) {
        if (error.data && error.data.response) {
            if (error.data.messages && error.data.messages.length > 0) {
                return Promise.reject(error.data.messages.join('<br/>'));
            } else if (error.data.response_code === 'RC000006') {
                if (!GetCookie(NOT_AUTH)) {
                    const path = window.location.pathname;
                    if (path !== '/login' && !path.includes("resetPassword")
                        && !path.includes("forgotpassword")) {
                        SetCookie(CACHE_ROUTE, path);
                        window.location = '/login';
                    }
                }
                SetCookie(NOT_AUTH, 401);
            }
            return Promise.reject(error.data.response)
        }
        if (error.response && error.response.status) {
            if (error.response.status === 401) {
                // const history = useHistory();
                if (!GetCookie(NOT_AUTH)) {
                    const path = window.location.pathname;
                    if (path !== '/login' && !path.includes("resetPassword")
                        && !path.includes("forgotpassword")) {
                        SetCookie(CACHE_ROUTE, path);
                        window.location = '/login';
                    }
                }
                SetCookie(NOT_AUTH, 401);
            } else if (error.response.status === 303) {
                // window.location = '/changepass';
                window.location.replace('/changepass');
                SetCookie(EXPIRY_PASS, 303);
            }
        }
        if (data?._download) {
            error.response = {data: 'Файл татахад алдаа гарлаа.'}
        }
        return Promise.reject(getInfoRespError(error.response || error.message))
    }
    return axiosInstance(options).then(onSuccess).catch(onError)
}
